import { PropsWithChildren } from 'react'

export default function KeyboardAware({ children }: PropsWithChildren) {
  return children
}
